import { useQuery } from "@tanstack/react-query";
import { ORGANISATION_BRANDS_QUERY_KEY } from "../constants";
import { OrganisationService } from "../services/organisation.service";

export default function useGetOrganisationBrands(brandOrganisationId: string) {
  const {
    data: organisationBrands,
    isFetching: isOrganisationBrandsFetching,
    error: organisationBrandsError,
    isSuccess: isOrganisationBrandsSuccess,
  } = useQuery({
    queryKey: [...ORGANISATION_BRANDS_QUERY_KEY, brandOrganisationId],
    queryFn: () =>
      OrganisationService.getOrganisationBrands(brandOrganisationId),
    enabled: !!brandOrganisationId,
  });

  return {
    organisationBrands,
    isOrganisationBrandsFetching,
    organisationBrandsError,
    isOrganisationBrandsSuccess,
  };
}
